import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../../../store/types'

export const accountsBankingProductMovementsFiltersSelector = (id: string) =>
  createSelector(
    [(state: RootState) => state.accounts.master.filters.bankingProduct.movements],
    (filters) => filters[id] ?? {},
  )
